import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { generateCertificatePDF } from '../utils';
import { useSelector } from 'react-redux';
import { getSubscription, selectUser } from '../../../reducers/user.selectors';
import { CourseRegistration } from '@klab-berlin/api-sdk/lib/types/responses/CourseRegistration';
import useRouter from '../../../utils/useRouter';
import { ampliConversionPath, routes } from '../../../constants';
import { ListItem } from '../ListItem';
import services from '../../../services';

const MyCertificatesPageItem: React.FC<{
  courseRegistration: CourseRegistration;
}> = ({ courseRegistration }) => {
  const { router } = useRouter();
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const { mindItem, certifiedAt, mindItemId } = courseRegistration;
  const subscription = useSelector(getSubscription);

  const formattedDate = moment(certifiedAt).format('DD.MM.YYYY');

  const onClick = async () => {
    if (!user?.isPremium) {
      services.track.ampliTrackPricingPlansViewedEvent(
        ampliConversionPath.CertificatePage,
        subscription?.status
      );
      return router.push(`/${routes.upgradePackageSelection.root}`);
    }
    
    const certificateUrl = await generateCertificatePDF(user, mindItemId);
    window.open(certificateUrl, '_blank');
  };

  return (
    <ListItem 
      header={mindItem?.course?.type}
      subHeader={`${t('completed on')} ${formattedDate}`}
      title={mindItem?.title}
      buttonText={user && user.isPremium ? t('Download certificate') : t('Upgrade to Download')}
      onButtonClick={onClick}
      testId='certificate-item'
    />
  );
};

export default MyCertificatesPageItem;
